import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  escalationSchema,
  createEscalationSchema,
  updateEscalationSchema,
  escalationListResponseSchema,
  escalationFiltersSchema,
  assignEscalationSchema,
} from '../schemas/escalations.schemas';
import { errorResponseSchema, paginationQuerySchema } from '../schemas/common.schemas';

const c = initContract();

export const escalationsContract = c.router({
  createEscalation: {
    method: 'POST',
    path: '/escalations',
    body: createEscalationSchema,
    responses: {
      201: escalationSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
      404: errorResponseSchema,
    },
    summary: 'Create a new escalation',
  },
  getEscalation: {
    method: 'GET',
    path: '/escalations/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    responses: {
      200: escalationSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get escalation by ID',
  },
  listEscalations: {
    method: 'GET',
    path: '/escalations',
    query: paginationQuerySchema.merge(escalationFiltersSchema),
    responses: {
      200: escalationListResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'List escalations with pagination and filters',
  },
  updateEscalation: {
    method: 'PATCH',
    path: '/escalations/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: updateEscalationSchema,
    responses: {
      200: escalationSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Update escalation',
  },
  assignEscalation: {
    method: 'POST',
    path: '/escalations/:id/assign',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: assignEscalationSchema,
    responses: {
      200: escalationSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Assign escalation to a user',
  },
  resolveEscalation: {
    method: 'POST',
    path: '/escalations/:id/resolve',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: z.object({
      resolution: z.string().min(1),
    }),
    responses: {
      200: escalationSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Mark escalation as resolved',
  },
});
